module.exports = __webpack_public_path__ + "img/6_kth_gbt5971-86.prt.7d3d9c7f.jpg";